module.exports = __webpack_public_path__ + "static/media/image.48fbf620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DevelopingABrandCharacter/image.jpg
// module id = 23
// module chunks = 0